const BasePage = r => require(['@/v2/views/components/BasePage'], r)

export default {
  path: '/v2',
  component: BasePage,
  children: [
    {
      path: '/v2/exam/index',
      name: 'ExamIndex',
      component: r => require(['@/v3/modules/exam/views/index'], r),
      meta: {
        title: '考试列表',
        url: '/exam/single',
        auth: ["Exam-List", "Region-Exam-Single"],
        keepAlive: true
      }
    },
    {
      path: '/region/exam/single',
      redirect: '/v2/exam/index'
    },
    {
      path: '/v2/exam/create',
      name: 'CreateExam',
      component: (r) => require(['@/v3/modules/exam/views/createExam'], r),
      meta: {
        title: '创建考试',
        parentPath: '/v2/exam/index'
      },
    },
    {
      path: '/v2/exam/edit/:id',
      name: 'EditExam',
      component: (r) => require(['@/v3/modules/exam/views/createExam'], r),
      meta: {
        title: '修改考试',
        parentPath: '/v2/exam/index'
      },
    },
    {
      path: '/v2/exam/edit-region/:id',
      name: 'EditRegionExam',
      component: (r) => require(['@/v3/modules/exam/views/editRegionExam'], r),
    },
    {
      path: '/region/exam/marking',
      redirect: '/v2/marking/index'
    },
    {
      path: '/v2/marking/index',
      name: 'MarkingIndex',
      component: r => require(['@/v3/modules/marking/views/index'], r),
      meta: {
        title: '考试批改',
        url: '/exam/marking',
        auth: ["Marking-List", "Region-Marking-List"],
        parentPath: '/region/exam/marking',
        keepAlive: true
      }
    },
    {
      path: '/v2/exam/monitoring',
      name: 'ExamMonitoring',
      component: r => require(['@/v3/modules/marking/views/monitoring'], r),
      meta: {
        title: '批阅监控',
        parentPath: '/v2/exam/index'
      },
      children: [
        {
          path: "/v2/exam/monitoring/progress/:id",
          name: "monitoring-progress",
          meta: {
            auth: "Exam-Marking",
            parentPath: '/v2/exam/index',
            hideFooter: true
          },
          component: r =>
            require(["@/v3/modules/marking/views/data/progress"], r)
        },
        {
          path: "/v2/exam/monitoring/spread/:id",
          name: "monitoring-spread",
          meta: {
            auth: "Exam-Marking",
            parentPath: '/v2/exam/index'
          },
          component: r =>
            require(["@/v3/modules/marking/views/data/spread"], r)
        },
        {
          path: "/v2/exam/monitoring/quality/:id",
          name: "monitoring-quality",
          meta: {
            auth: "Exam-Marking",
            parentPath: '/v2/exam/index'
          },
          component: r =>
            require(["@/v3/modules/marking/views/data/quality"], r)
        },
        {
          path: "/v2/exam/monitoring/monitor/:id",
          name: "monitoring-monitor",
          meta: {
            auth: "Exam-Marking",
            parentPath: '/v2/exam/index'
          },
          component: r =>
            require(["@/v3/modules/marking/views/data/monitor"], r)
        },
        {
          path: "/v2/exam/monitoring/check/:id",
          name: "monitoring-check",
          meta: {
            auth: "Exam-Marking",
            parentPath: '/v2/exam/index'
          },
          component: r =>
            require(["@/v3/modules/marking/views/checkPaper"], r)
        },
      ]
    },
    {
      path: '/v2/ques/doc2ques',
      name: 'Doc2Ques',
      component: r => require(['@/v3/modules/exam/views/ques/doc2ques'], r),
      meta: {
        title: '试卷管理',
        keepAlive: false,
        parentPath: '/v2/exam/index',
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer',
        keepAlive: true
      }
    },
    {
      path: '/v2/ques/paper-preview',
      name: 'PaperPreview',
      component: r => require(['@/v3/modules/exam/views/ques/paper-preview'], r),
      meta: {
        title: '试卷管理',
        keepAlive: false,
        hideHeader: 'hide-header',
        hideFooter: 'hide-footer'
      }
    },
    {
      path: '/v2/exam/answer/:id',
      name: 'ExamAnswer',
      component: r => require(['@/v2/views/exam/answer'], r),
      meta: {
        title: '答题卡设置',
        keepAlive: false,
        parentPath: '/v2/exam/index',
      }
    },
    {
      path: "/exam/answer/scan-summary/:id",
      name: 'ScanSummary',
      component: r => require(['@/v3/modules/exam/views/scan-summary'], r),
      meta: {
        title: '区域扫描统计',
        keepAlive: false,
        parentPath: '/v2/exam/index',
      }
    }
  ]
}